import React, { Component } from 'react';
import Header from "../../header";
import { Row, Typography} from "antd";
import './homepage.css';
import Texts from "../../../utils/Text";
import bgIcon from '../../../utils/backg-image.jpeg';

const { Text } = Typography;


export default class Homepage extends Component {
  state = {
      color: 'white',
      isMobile: window.screen.width < 769,
  };

  render() {
      return (
          <div className="full-height image-bg" style={{backgroundImage: `url(${bgIcon})`}}>
              <Header/>
              <div className="content" style={{verticalAlign: "middle", height: '100vh'}}>
                  <div style={{verticalAlign: "middle", height: '100vh'}}>
                      <Row className='homepage-title'>
                          <Text className="montserrat">{Texts('homepage', 'title').toUpperCase()}</Text>
                      </Row>
                      <Row className='homepage-subtitle'>
                          <Text className="montserrat ">{Texts('homepage', 'description')}</Text>
                      </Row>
                  </div>
              </div>
          </div>
          );
  }
}

